import React, { useState, useEffect, useCallback } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
// import "../Style/customer_v2.scss";

//API
import ItemService from "../../../../services/customer_appCommonService";
// import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import Constants from "../../../../common/SupplierConstants";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import {
  getTodaysData,
  validateBankAccount,
  // validateBankAccount,
  validateContactNumber,
  validateEmail,
  // validateEmail,
  validateName,
  validateRequired,
  validPostalCode,
} from "../../../../common/Validations";
// import CustomerConstants from "../../../../common/CustomerConstants";
// import toast from "react-hot-toast";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import Layout from "../../../../Layout/Layout";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import CustomerConstants from "../../../../common/CustomerConstants";
import toast from "react-hot-toast";
import {
  vendorCategoryData,
  dropdownOption,
  // employeeGender,
  failureModalData,
  employeeGender,
} from "../CustomerV5Constant/MRSupplierConstant";
import { doctorManagerDropDownOption } from "../UserMaster/UserRegistrationConstant";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  VALID_BANK_ACC: "validate banck account number",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  DOC_NUMBER: "Invalid Document Number",
};

const SupplierRegistrationDetailsMR = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Vendor");
  // let customerData = useSelector((state) => state?.customer?.employee); // User Details from Store
  const appConfig = useSelector((state) => state?.app?.appConfig); // Application Details from Store
  let userData = useSelector((state) => state?.user?.data);

  let supplierID = useSelector((state) => state?.supplier?.supplierID); // User Details from Store
  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store

  // let requiredFields = [];

  const [getDropdownData, setDropdownData] = useState("");
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);

  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getcontactPosition, setcontactPosition] = useState([]);
  const [getTitle, setTitle] = useState([]);

  const [edit, setEdit] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [getcustomerContactPerson, setcustomerContactPerson] = useState([
    {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    },
  ]);
  const [getDocumentTypeData, setDocumentTypeData] = useState([
    {
      id: Date.now(),
      name: "Document 1",
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "29AADCN1012B1Z6",
    },
  ]);

  const [getdocumentType, setdocumentType] = useState([]);
  const [showOtherRoleInput, setShowOtherRoleInput] = useState(false);

  const [getState, setState] = useState([]);
  const [getCountry, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const [validation, setValidation] = useState({
    employeeName: "",
    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
  });

  //bank state
  const [getBankDetails, setBankDetails] = useState([]);
  const [getBankDetailsData, setBankDetailsData] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);
  // eslint-disable-next-line
  const [getCustomerTypeCode, setCustomerTypeCode] = useState();

  const [getVendorCategory, setVendorCategory] = useState([]);
  const [selectedVendorCategory, setSelectedVendorCategory] = useState(null);

  const [originalFormData, setOriginalFormData] = useState(null);
  const [originalVendorCategory, setOriginalVendorCategory] = useState(null);
  const [originalSelectedVendorCategory, setOriginalSelectedVendorCategory] =
    useState(null);
  const [originalContactPerson, setOriginalContactPerson] = useState([]);
  const [originalDocuments, setOriginalDocuments] = useState([]);
  const [originalBankDetails, setOriginalBankDetails] = useState([]);
  const [originalDoctorsList, setOriginalDoctorsList] = useState([]);

  const [getDoctorsList, setDoctorsList] = useState([]);

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    employeeName: "",
    address: "",
    address2: "",
    city: "",
    country: "IN - India",
    state: "IN - Karnataka",
    cityPostalCode: "",
    companyCode: "",

    version: "v0",
    status: "Registered",
    category: "VENDOR",

    routeNumber: "",
    commission: "Yes",
    commissionRate: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    joiningDate: getTodaysData(),
    email: "",
    mobileNr: "",
    plantAddress: appConfig?.customerPlantAddress,
    projectLocation: "",

    customerTypeCode: "",
    customerTypeDesc: "",

    jobRole: "",
    otherJobRole: "",

    // V11 Doctor fields
    doctorTitle: "",
    doctorEmpName: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    employeeGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",
    doctorHospitalName: "",
    doctorHospitalAddress: "",
    doctorHospitalCity: "",
    doctorHospitalState: "",
    doctorHospitalCountry: "",
    doctorHospitalPincode: "",
    doctorManagerName: "",
    doctorManagerNameCode: "",
  });

  const doctorInitialData = {
    id: Date.now(),
    doctorName: "",
    doctorTitle: "",
    doctorSpecialityCode: "",
    doctorSpecialityName: "",
    doctorType: "",
    doctorGender: "",
    doctorClass: "",
    doctorRentPercentage: "",
    doctorDiscountPercentage: "",
  };

  const bankInfoInitialData = {
    id: "",
    bankNotListed: "",
    bankAccountNumber: "",
    bankKey: "",
    bankName: "",
    bankCountry: "",
    bankAddress: "",
    AccountHolderName: "",
    bankCompanyletterhead: "",
    bankConfirmationLetter: "",
    chipsCode: "",
    swiftIfscCode: "",
    bankInfoTemplate: "",
    preferredCurrency: "",
  };

  //  Date format converter function
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";

    // Check if date is in DD-MM-YYYY format (bulk upload)
    if (dateString.includes("-")) {
      const parts = dateString.split("-");

      // If it's DD-MM-YYYY (day first)
      if (parts[0].length === 2 && parts[2].length === 4) {
        const [day, month, year] = parts;
        return `${year}-${month}-${day}`; // Convert to YYYY-MM-DD
      }
    }

    // Already in YYYY-MM-DD format or other format
    return dateString;
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };

  const loadFirstLevelData = useCallback(async () => {
    if (supplierID || userInfo?.userId) {
      let obj = { userId: supplierID || userInfo?.userId };

      const toastId = toast.loading("Loading...", { position: "top-right" });

      try {
        const item = await ItemService.getUserDetail(obj);

        if (item?.status === 200) {
          const backendData = item?.data;

          //  FIX: Extract doctor details from doctorsDetails array for V11
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const vendorCode = backendData.vendorCategory[0].vendorCategoryCode;

            // If V11 (Doctor), extract doctor info from doctorsDetails[0]
            if (
              vendorCode === "V11" &&
              backendData.doctorsDetails &&
              backendData.doctorsDetails.length > 0
            ) {
              const doctorInfo = backendData.doctorsDetails[0];

              // Merge doctor info into formInputs
              backendData.doctorTitle = doctorInfo.doctorTitle || "";
              backendData.doctorEmpName = doctorInfo.doctorEmpName || "";
              backendData.doctorSpecialityCode =
                doctorInfo.doctorSpecialityCode || "";
              backendData.doctorSpecialityName =
                doctorInfo.doctorSpecialityName || "";
              backendData.doctorType = doctorInfo.doctorType || "";
              backendData.employeeGender = doctorInfo.doctorGender || "";
              backendData.doctorClass = doctorInfo.doctorClass || "";
              backendData.doctorRentPercentage =
                doctorInfo.doctorRentPercentage || "";
              backendData.doctorDiscountPercentage =
                doctorInfo.doctorDiscountPercentage || "";
              backendData.doctorHospitalName =
                doctorInfo.doctorHospitalName || "";
              backendData.doctorHospitalAddress =
                doctorInfo.doctorHospitalAddress || "";
              backendData.doctorHospitalCity =
                doctorInfo.doctorHospitalCity || "";
              backendData.doctorHospitalState =
                doctorInfo.doctorHospitalState || "";
              backendData.doctorHospitalCountry =
                doctorInfo.doctorHospitalCountry || "";
              backendData.doctorHospitalPincode =
                doctorInfo.doctorHospitalPincode || "";
              backendData.doctorManagerName =
                doctorInfo.doctorManagerName || "";
              backendData.doctorManagerCode =
                doctorInfo.doctorManagerCode || "";
            }
          }

          setFormInputs(backendData);
          setcustomerContactPerson(backendData?.contactDetails || []);
          setDocumentTypeData(backendData?.certifications || []);
          setBankDetails(
            backendData?.bandkDetails || backendData?.bankDetails || [],
          );

          //  For V04 (Hospital), set doctors list
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory[0]?.vendorCategoryCode === "V04"
          ) {
            setDoctorsList(backendData?.doctorsDetails || []);
          } else {
            setDoctorsList([]); // Clear for non-hospital categories
          }

          // Transform vendorCategory from backend
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const backendCategory = backendData.vendorCategory[0];
            const matchedCategory = vendorCategoryData.find(
              (cat) => cat.code === backendCategory.vendorCategoryCode,
            );

            if (matchedCategory) {
              setSelectedVendorCategory({
                id: matchedCategory.id,
                code: matchedCategory.code,
                name: matchedCategory.name,
                description: matchedCategory.description,
              });

              setVendorCategory([
                {
                  vendorCategoryCode: backendCategory.vendorCategoryCode,
                  vendorCategoryDesc:
                    backendCategory.vendorCategoryDesc ||
                    backendCategory.vendorCategoryDescription,
                  vendorCategoryName:
                    backendCategory.vendorCategoryName ||
                    backendCategory.vandorCategory,
                },
              ]);
            }
          }

          // Store originals
          setOriginalFormData(JSON.parse(JSON.stringify(backendData)));
          setOriginalVendorCategory(
            backendData?.vendorCategory ? [...backendData.vendorCategory] : [],
          );
          setOriginalContactPerson(
            backendData?.contactDetails ? [...backendData.contactDetails] : [],
          );
          setOriginalDocuments(
            backendData?.certifications ? [...backendData.certifications] : [],
          );
          setOriginalBankDetails(
            backendData?.bandkDetails || backendData?.bankDetails
              ? [...(backendData.bandkDetails || backendData.bankDetails)]
              : [],
          );

          // Store original doctors list (for V04)
          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory[0]?.vendorCategoryCode === "V04"
          ) {
            setOriginalDoctorsList(
              backendData?.doctorsDetails
                ? [...backendData.doctorsDetails]
                : [],
            );
          } else {
            setOriginalDoctorsList([]);
          }

          if (
            backendData?.vendorCategory &&
            backendData.vendorCategory.length > 0
          ) {
            const backendCategory = backendData.vendorCategory[0];
            const matchedCategory = vendorCategoryData.find(
              (cat) => cat.code === backendCategory.vendorCategoryCode,
            );
            if (matchedCategory) {
              setOriginalSelectedVendorCategory({
                id: matchedCategory.id,
                code: matchedCategory.code,
                name: matchedCategory.name,
                description: matchedCategory.description,
              });
            }
          }
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }

        toast.dismiss(toastId);
      } catch (error) {
        console.error("Error loading data:", error);
        toast.error("Failed to load data", { position: "top-right" });
        toast.dismiss(toastId);
      }
    } else {
      navigate(CustomerConstants.SUPPILER_LIST_MR);
    }
  }, [supplierID, userInfo?.userId, navigate]);

  useEffect(() => {
    loadFirstLevelData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadFirstLevelData]);

  //Load Master Data
  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
    // let obj4 = {
    //   codeType: "companyCode",
    // };
    // await ItemService.getMasterData(obj4).then((item) => {
    //   // console.log('>> item!',item);
    //   if (item?.status === 200) {
    //     setCompanyCode(item?.data);
    //   } else {
    //     setCompanyCode([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });

    //generateCustomerQuery
    let obj5 = {
      queryName: "Get_CompanyMaster_List",
      page: 1,
      per_page: 9999,
      searchTerm: "",
      timeZone: "Asia/Calcutta",
    };
    await ItemService.generateCustomerQuery(obj5).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };
  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // const formatDateForInput = (dateString) => {
  //   if (!dateString) return "";
  //   const str = String(dateString).trim(); // Coerce to string safely
  //   if (str.includes("-")) {
  //     const parts = str.split("-");
  //     if (parts[0].length === 4) {
  //       // YYYY-MM-DD -> already good or reformat
  //       return str;
  //     }
  //     // DD-MM-YYYY handling
  //     if (
  //       parts.length === 3 &&
  //       parts[0].length === 2 &&
  //       parts[2].length === 4
  //     ) {
  //       const [day, month, year] = parts;
  //       return `${year}-${month}-${day}`;
  //     }
  //     return str;
  //   }
  //   // Handle MM/DD/YYYY like "1/1/2025"
  //   if (str.includes("/")) {
  //     const parts = str.split("/");
  //     if (parts.length === 3 && parts[2].length === 4) {
  //       const [month, day, year] = parts.map((p) => p.padStart(2, "0"));
  //       return `${year}-${month}-${day}`;
  //     }
  //   }
  //   return str; // Fallback: return as-is
  // };

  // eslint-disable-next-line
  const [getCompanyProfile, setCompanyProfile] = useState({
    // customerCode: "",
    // typeOfCompany: "",
    // typeOfFirm: "",
    // creditLimit: "",
    // creditLimitINR: "",
    // typeOfCustomerSegment: "",
    // creditPeriodDays: "",
    // numberOfYearsInBusiness: "",
    // security: "",
    // detailsOfSecurity: "",
    // paymentType: "",

    creditAvailableAmt: "",
    creditHoldAmt: "",
    creditUtilizedAmt: "",
    creditMaxLimit: "",
    creditSuspendedAmt: "",
    creditLimitExpiryDate: "",
    creditLimitNextRenewalDate: "",
    creditPeriod: "",
  });
  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);

  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textField === "state") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "vendorCategory") {
      setSelectedVendorCategory({
        id: getDropdownData.id,
        code: getDropdownData.code,
        name: getDropdownData.name,
        description: getDropdownData.description,
      });

      setVendorCategory([
        {
          vendorCategoryCode: getDropdownData.code,
          vendorCategoryDesc: getDropdownData.description,
          vendorCategoryName: getDropdownData.name,
        },
      ]);

      setValidation((prev) => ({ ...prev, vendorCategory: "" }));
    } else if (getDropdownData?.textField === "companyCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.companyCode,
        [getDropdownData?.textCode]: getDropdownData?.companyCodeCode,
        [getDropdownData?.textDesc]: getDropdownData?.companyCodeDesc,
      }));
      // getStateData(getDropdownData?.code);
    } else if (getDropdownData?.textField === "employeeGender") {
      setFormInputs((prev) => ({
        ...prev,
        employeeGender: getDropdownData.name,
        employeeGenderCode: getDropdownData.code,
      }));
    } else if (getDropdownData?.textField === "doctorManagerName") {
      setFormInputs((prev) => ({
        ...prev,
        doctorManagerName: getDropdownData.name,
        doctorManagerNameCode: getDropdownData.code,
      }));
    } else if (getDropdownData?.textCode === "salesOfficerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textCode === "typeOfFirmCode") {
      setCompanyProfile((companyProfile) => ({
        ...companyProfile,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textCode === "paymentTypeCode") {
      setCompanyProfile((companyProfile) => ({
        ...companyProfile,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.codeType === "jobtitle") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "title") {
      setcustomerContactPerson((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.codeType === "documentType") {
      setDocumentTypeData((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData?.index
            ? {
                ...doc,
                [getDropdownData?.textField]: getDropdownData?.name,
                [getDropdownData?.textCode]: getDropdownData?.code,
                [getDropdownData?.textDesc]: getDropdownData?.description,
              }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "doctorGender") {
      setDoctorsList((prev) =>
        prev.map((doc) =>
          doc.id === getDropdownData.index
            ? { ...doc, doctorGender: getDropdownData.name }
            : doc,
        ),
      );
    } else if (getDropdownData?.textField === "swiftIfscCode") {
      setBankDetails((prev) =>
        prev.map((bank) =>
          bank.id === getDropdownData.index
            ? {
                ...bank,
                swiftIfscCode: getDropdownData.name,
                swiftIfscCodeCode: getDropdownData.code,
              }
            : bank,
        ),
      );
    }

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  useEffect(() => {
    if (getDropdownData?.textCode === "jobRoleCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));

      // Show input only if code is "4" (Others)
      if (getDropdownData?.code === "4") {
        setShowOtherRoleInput(true);
      } else {
        setShowOtherRoleInput(false);
        setFormInputs((prev) => ({
          ...prev,
          otherJobRole: "",
        }));
      }
    }

    // Other conditions remain unchanged...

    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
  }, [getDropdownData]);

  const onInputChange = ({ target: { name, value } }) => {
    const errors = {};
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
    validateName(name === "employeeName" ? value : "")
      ? (errors.employeeName = "")
      : (errors.employeeName = message.VALID_CUSTOMER_NAME);
    validPostalCode(name === "cityPostalCode" ? value : "")
      ? (errors.cityPostalCode = "")
      : (errors.cityPostalCode = message.VALID_POSTAL_CODE);

    if (name === "email") {
      if (!validateEmail(value)) {
        errors.email = message.VALID_MAIL_ID;
      }
    }

    if (name === "mobileNr") {
      if (!validateContactNumber(value)) {
        errors.mobileNr = message.MOBILE_NUMBER;
      }
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  const handleEdit = () => {
    setEdit(false); // Hide Edit button, Show Update/Cancel
    setDisabled(false); // Enable inputs
  };

  const handleCancel = () => {
    setEdit(true);
    setDisabled(true);

    if (originalFormData)
      setFormInputs(JSON.parse(JSON.stringify(originalFormData)));
    if (originalVendorCategory) setVendorCategory([...originalVendorCategory]);
    if (originalSelectedVendorCategory)
      setSelectedVendorCategory({ ...originalSelectedVendorCategory });
    if (originalContactPerson)
      setcustomerContactPerson([...originalContactPerson]);
    if (originalDocuments) setDocumentTypeData([...originalDocuments]);
    if (originalBankDetails) setBankDetails([...originalBankDetails]);
    if (originalDoctorsList) setDoctorsList([...originalDoctorsList]);

    setValidation({});
  };

  //  BUILD PAYLOAD FOR UPDATE
  const buildPayload = () => {
    const payload = {
      ...formInputs,
      firstName: formInputs.employeeName,
      organisationName: formInputs.employeeName,
      contactDetails: getcustomerContactPerson,
      certifications: getDocumentTypeData,
      bandkDetails: getBankDetails,
      vendorCategory: getVendorCategory,
      customerTypeCode: getCustomerTypeCode || "S01",
      disableWorkFlow: true,
    };

    // CASE 1: INDIVIDUAL DOCTOR (V11)
    if (selectedVendorCategory?.code === "V11") {
      payload.doctorsDetails = [
        {
          doctorName: formInputs.employeeName,
          doctorTitle: formInputs.doctorTitle,
          doctorEmpName: formInputs.doctorEmpName,
          doctorSpecialityCode: formInputs.doctorSpecialityCode,
          doctorSpecialityName: formInputs.doctorSpecialityName,
          doctorType: formInputs.doctorType,
          doctorGender: formInputs.employeeGender,
          doctorClass: formInputs.doctorClass,
          doctorRentPercentage: formInputs.doctorRentPercentage,
          doctorDiscountPercentage: formInputs.doctorDiscountPercentage,
          doctorHospitalName: formInputs.doctorHospitalName,
          doctorHospitalAddress: formInputs.doctorHospitalAddress,
          doctorHospitalCity: formInputs.doctorHospitalCity,
          doctorHospitalState: formInputs.doctorHospitalState,
          doctorHospitalCountry: formInputs.doctorHospitalCountry,
          doctorHospitalPincode: formInputs.doctorHospitalPincode,
          doctorManagerName: formInputs.doctorManagerName,
          doctorManagerCode: formInputs.doctorManagerNameCode,
        },
      ];
    }
    // CASE 2: HOSPITAL (V04)
    else if (selectedVendorCategory?.code === "V04") {
      payload.doctorsDetails = getDoctorsList.map((doctor) => ({
        doctorName: doctor.doctorName,
        doctorTitle: doctor.doctorTitle,
        doctorSpecialityCode: doctor.doctorSpecialityCode,
        doctorSpecialityName: doctor.doctorSpecialityName,
        doctorType: doctor.doctorType,
        doctorGender: doctor.doctorGender,
        doctorClass: doctor.doctorClass,
        doctorRentPercentage: doctor.doctorRentPercentage,
        doctorDiscountPercentage: doctor.doctorDiscountPercentage,

        // Each doctor gets hospital info
        doctorHospitalName: formInputs.employeeName,
        doctorHospitalAddress: formInputs.address,
        doctorHospitalCity: formInputs.city,
        doctorHospitalState: formInputs.state,
        doctorHospitalCountry: formInputs.country,
        doctorHospitalPincode: formInputs.cityPostalCode,
      }));
    } else {
      payload.doctorsDetails = [];
    }

    return payload;
  };

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  // eslint-disable-next-line no-unused-vars
  const navigateToLogin = () => {
    navigate(Constants.LOGIN);
  };

  /* ---------------------Customer Contact Person -------- */

  const deleteCustomerContactPerosn = (id) => {
    const updatedData1 = getcustomerContactPerson.filter(
      (doc) => doc.id !== id,
    );
    setcustomerContactPerson(updatedData1);
  };
  // eslint-disable-next-line
  const addCustomerCantactPerson = () => {
    const newDocument = {
      id: Date.now(),
      contactPosition: "",
      contactTitle: "",
      contactName: "",
      contactNumber: "",
      contactEmail: "",
    };
    setcustomerContactPerson((prevData) => [...prevData, newDocument]);
  };

  const handleChangeCustomerContacts = (id, fieldName, value) => {
    const errors = {};

    // Required field validation
    if (!validateRequired(value)) {
      errors[fieldName] = `${fieldName} is required.`;
    }

    // Contact number format validation
    if (fieldName === "contactNumber" && validateRequired(value)) {
      if (!validateContactNumber(value)) {
        errors[fieldName] = "Invalid contact number. Must be 10 digits.";
      }
    }
    setcustomerContactPerson((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );
    // Update validation state
    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  /* ---------------------Document Type  03rd block-------- */

  const deleteDocumentType = (id) => {
    const updatedData1 = getDocumentTypeData.filter((doc) => doc.id !== id);
    setDocumentTypeData(updatedData1);
  };
  // eslint-disable-next-line
  const addDocumentType = () => {
    const newDocument = {
      id: Date.now(),
      name: `Document ${getDocumentTypeData.length + 1}`,
      documentType: "",
      documentNumber: "",
      issueDate: "",
      issuingAuthority: "",
      certificateCode: "",
    };
    setDocumentTypeData((prevData) => [...prevData, newDocument]);
  };
  const handleInputChange = (id, fieldName, value) => {
    const errors = {};

    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === id ? { ...doc, [fieldName]: value } : doc,
      ),
    );

    setValidation((prev) => ({
      ...prev,
      [`${id}_${fieldName}`]: errors[fieldName] || "",
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setDocumentTypeData((prevData) =>
      prevData.map((doc) =>
        doc.id === data.fieldId
          ? { ...doc, [data.fieldName]: data.attachmentId }
          : doc,
      ),
    );
  };

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //bank start
  //Load Bank Master Data
  const getBankMasterData = async () => {
    await ItemService.getBankMasterData().then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setBankDetailsData(item?.data);
      } else {
        setBankDetailsData([]);
        console.log(">> Error: Loading getBankMasterData");
      }
    });
  };
  useEffect(() => {
    getBankMasterData(); // Load Bank Details
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const addBankForm = () => {
  //   const uniqueId = Date.now().toString(); // or use uuid if you prefer
  //   const newForm = { ...bankInfoInitialData, id: uniqueId };
  //   setBankDetails([...getBankDetails, newForm]);
  // };
  const addBankForm = () => {
    const uniqueId = Date.now().toString(); // or use uuid if you prefer
    const newForm = { ...bankInfoInitialData, id: uniqueId };
    setBankDetails([...getBankDetails, newForm]);
  };

  const removeBankForm = (indexToRemove) => {
    setBankDetails(
      getBankDetails.filter((form, index) => index !== indexToRemove),
    );
  };

  // const handleUpdate = async () => {
  //   // console.log("Updating vendor...");

  //   // Validation
  //   if (!formInputs.employeeName) {
  //     toast.error("Vendor name is required");
  //     return;
  //   }

  //   if (!formInputs.email) {
  //     toast.error("Email is required");
  //     return;
  //   }

  //   // Remove MongoDB internal fields
  //   const { _id, __v, password, ...cleanFormInputs } = formInputs;

  //   // Build payload
  //   const updatedPayload = {
  //     userId: supplierID || userInfo?.userId,
  //     ...cleanFormInputs,

  //     // Arrays
  //     contactDetails: getcustomerContactPerson,
  //     certifications: getDocumentTypeData,
  //     bandkDetails: getBankDetails,

  //     // Computed fields
  //     firstName: formInputs.employeeName,
  //     organisationName: formInputs.employeeName,

  //     // Metadata
  //     updatedAt: new Date().toISOString(),
  //     updatedBy: userInfo?.userId || "",
  //     timeZone: "Asia/Calcutta",
  //     vendorCategory: getVendorCategory,
  //   };

  //   // console.log("📤 Update Payload:", updatedPayload);

  //   setDisabled(true);
  //   const toastId = toast.loading("Updating vendor details...");

  //   try {
  //     const response = await ItemService.updateSupplierDocs(updatedPayload);

  //     if (response?.status === 200) {
  //       toast.success("Vendor updated successfully!", {
  //         id: toastId,
  //         duration: 3000,
  //       });

  //       // Switch to view mode
  //       setEdit(true);
  //       setDisabled(true);

  //       // Reload data to ensure UI shows what's in database
  //       await loadFirstLevelData();
  //     } else {
  //       toast.error(response?.message || "Update failed", {
  //         id: toastId,
  //       });
  //       setDisabled(false); // Re-enable for retry
  //     }
  //   } catch (err) {
  //     console.error("Update Error:", err);
  //     toast.error(err?.response?.data?.message || "Something went wrong", {
  //       id: toastId,
  //     });
  //     setDisabled(false); // Re-enable for retry
  //   }
  // };

  const handleUpdate = async () => {
    const requiredFields = [];
    let hasError = false;
    const validationErrors = {};

    // Basic validations
    if (!validateRequired(formInputs.employeeName)) {
      validationErrors.employeeName = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validateName(formInputs.employeeName)) {
      validationErrors.employeeName = message.VALID_CUSTOMER_NAME;
      requiredFields.push(message.VALID_CUSTOMER_NAME);
      hasError = true;
    }

    if (!validateRequired(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validateContactNumber(formInputs.mobileNr)) {
      validationErrors.mobileNr = message.MOBILE_NUMBER;
      requiredFields.push(message.MOBILE_NUMBER);
      hasError = true;
    }

    if (!validateRequired(formInputs.email)) {
      validationErrors.email = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validateEmail(formInputs.email)) {
      validationErrors.email = message.VALID_MAIL_ID;
      requiredFields.push(message.VALID_MAIL_ID);
      hasError = true;
    }

    if (!validateRequired(formInputs.address)) {
      validationErrors.address = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    }

    if (!validateRequired(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    } else if (!validPostalCode(formInputs.cityPostalCode)) {
      validationErrors.cityPostalCode = message.VALID_POSTAL_CODE;
      requiredFields.push(message.VALID_POSTAL_CODE);
      hasError = true;
    }

    // if (!selectedVendorCategory?.code) {
    //   validationErrors.vendorCategory = message.FILL_REQUIRED_FIELD;
    //   requiredFields.push(message.FILL_REQUIRED_FIELD);
    //   hasError = true;
    // }

    if (!validateRequired(formInputs.companyCode)) {
      validationErrors.companyCode = message.FILL_REQUIRED_FIELD;
      requiredFields.push(message.FILL_REQUIRED_FIELD);
      hasError = true;
    }

    if (!selectedVendorCategory || !selectedVendorCategory.name) {
      requiredFields.push("Vendor Category is required");
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      setValidation((prev) => ({
        ...prev,
        vendorCategory: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    // V11 validation
    if (selectedVendorCategory?.code === "V11") {
      if (!validateRequired(formInputs.doctorHospitalName)) {
        validationErrors.doctorHospitalName = message.FILL_REQUIRED_FIELD;
        requiredFields.push(message.FILL_REQUIRED_FIELD);
        hasError = true;
      }
      if (!validateRequired(formInputs.doctorType)) {
        validationErrors.doctorType = message.FILL_REQUIRED_FIELD;
        requiredFields.push(message.FILL_REQUIRED_FIELD);
        hasError = true;
      }
    }

    // Contact person validation
    getcustomerContactPerson.forEach((doc) => {
      const id = doc.id;
      if (!doc.contactPosition) {
        validationErrors[`${id}_contactPosition`] = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!doc.contactName) {
        validationErrors[`${id}_contactName`] = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateName(doc.contactName)) {
        validationErrors[`${id}_contactName`] = message.VALID_CUSTOMER_NAME;
        hasError = true;
      }
      if (!doc.contactNumber) {
        validationErrors[`${id}_contactNumber`] = message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateContactNumber(doc.contactNumber)) {
        validationErrors[`${id}_contactNumber`] = message.VALID_CONTACT_NUMBER;
        hasError = true;
      }
    });

    // Document validation
    getDocumentTypeData.forEach((doc) => {
      const id = doc.id;
      if (!doc.documentType) {
        validationErrors[`${id}_documentType`] = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
      if (!doc.documentNumber) {
        validationErrors[`${id}_documentNumber`] = message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    });

    // Bank validation
    getBankDetails.forEach((doc) => {
      const id = doc.id;
      if (!doc.bankAccountNumber) {
        validationErrors[`${id}_bankAccountNumber`] =
          message.FILL_REQUIRED_FIELD;
        hasError = true;
      } else if (!validateBankAccount(doc.bankAccountNumber)) {
        validationErrors[`${id}_bankAccountNumber`] = message.VALID_BANK_ACC;
        hasError = true;
      }
      if (!doc.AccountHolderName) {
        validationErrors[`${id}_AccountHolderName`] =
          message.FILL_REQUIRED_FIELD;
        hasError = true;
      }
    });

    setValidation(validationErrors);

    if (hasError) {
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }

    const payload = buildPayload();
    const { _id, __v, password, ...cleanPayload } = payload;

    const updatedPayload = {
      ...cleanPayload,
      updatedAt: new Date().toISOString(),
      updatedBy: userInfo?.userId || "",
      timeZone: "Asia/Calcutta",
    };

    setDisabled(true);
    const toastId = toast.loading("Updating...");

    try {
      // console.log("payload for update", updatedPayload);
      const response = await ItemService.updateSupplierDocs(updatedPayload);

      if (response?.status === 200) {
        toast.success("Updated successfully!", { id: toastId });
        setEdit(true);
        setDisabled(true);
        await loadFirstLevelData();
      } else {
        toast.error(response?.message || "Update failed", { id: toastId });
        setDisabled(false);
      }
    } catch (err) {
      console.error("Update Error:", err);
      toast.error("Something went wrong", { id: toastId });
      setDisabled(false);
    }
  };

  const addDoctor = () => {
    setDoctorsList((prev) => [
      ...prev,
      { ...doctorInitialData, id: Date.now() },
    ]);
  };

  const deleteDoctor = (id) => {
    setDoctorsList((prev) => prev.filter((doc) => doc.id !== id));
  };

  const handleDoctorInputChange = (id, fieldName, value) => {
    setDoctorsList((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, [fieldName]: value } : doc)),
    );
  };

  useEffect(() => {
    setBankDetails([...getBankDetails, bankInfoInitialData]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeBankInfo = (id, key, value) => {
    const updatedBankDetails = getBankDetails.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          [key]: value,
          ...(key === "bankKey" &&
            (() => {
              const selectedBank = getBankDetailsData.find(
                (bank) => bank.name === value,
              );
              return selectedBank
                ? {
                    bankCountryDescription: selectedBank.bankCountryDescription,
                    bankAccountName: selectedBank.bankAccountName,
                    bankAddress: selectedBank.bankAddress,
                    bankBranchName: selectedBank.bankBranchName,
                    bankCurrency: selectedBank.bankCurrency,
                  }
                : {};
            })()),
        };
      }
      return item;
    });

    setBankDetails(updatedBankDetails);

    // Validate
    const errorMsg = !value ? `${key} is required.` : "";

    setValidation((prev) => ({
      ...prev,
      [`${id}_${key}`]: errorMsg,
    }));
  };

  const onSuccessUploadBankDocumentType = (data, index) => {
    const updatedBankDetails = [...getBankDetails];
    updatedBankDetails[index][data.fieldName] = data.attachmentId;
    setBankDetails(updatedBankDetails);
  };
  // eslint-disable-next-line
  const [getFuelHistory, setFuelHistory] = useState();

  const handleAttachmentDeleted = ({
    attachmentId,
    hasFiles,
    remainingCount,
  }) => {
    // If NO files remain, clear the field
    if (!hasFiles) {
      console.log("No files remaining, clearing attachment");
      setFormInputs((prev) => ({
        ...prev,
        [attachmentId.fieldName || attachmentId]: "", // Clear the attachment ID
      }));
    } else {
      // If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };

  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={10} lg={10} className="">
                <h2 className="mainTitle">Vendor Details</h2>
                <p className="subText">
                  {/* Register as a new Employee or Sub-Employee with our Company */}
                </p>
              </Col>
              {edit ? (
                /* VIEW MODE: Show Edit Button */
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end"
                >
                  <button className="btn btn-primary" onClick={handleEdit}>
                    <i className="bi bi-pencil-square px-2"></i>
                    Edit
                  </button>
                </Col>
              ) : (
                /* EDIT MODE: Show Update and Cancel Buttons */
                <Col
                  xs={12}
                  md={2}
                  lg={2}
                  className="d-flex justify-content-end gap-2"
                >
                  <button
                    className="btn btn-primary"
                    onClick={handleUpdate}
                    disabled={disabled} // Disabled while API is loading
                  >
                    <i className="bi bi-arrow-repeat px-2"></i>
                    Update
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={handleCancel}
                    disabled={disabled} // Disabled while API is loading
                  >
                    <i className="bi bi-x-circle px-2"></i>
                    Cancel
                  </button>
                </Col>
              )}
            </Row>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">V</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Vendor </span>
                      <span className="subHeaderTitle">Vendor Details</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {showOtherRoleInput && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Role"
                              name="otherJobRole"
                              placeholder=""
                              value={formInputs.otherJobRole || ""}
                              onChange={onInputChange}
                              error={validation.otherJobRole}
                              disabled={disabled}
                            />
                          </Col>
                        </>
                      )}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Vendor Category"
                          name="vendorCategory"
                          code="vendorCategoryCode"
                          description="vendorCategoryDesc"
                          data={vendorCategoryData}
                          id="vendorCategory"
                          iconClassName="dropdownIcon"
                          setValue={selectedVendorCategory}
                          error={validation?.vendorCategory}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Name"
                          name="employeeName"
                          placeholder=""
                          value={formInputs?.employeeName || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.employeeName}
                          disabled={disabled}
                        />
                      </Col>
                      {/* V11 FIELDS */}
                      {selectedVendorCategory?.code === "V11" && (
                        <>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Title"
                              name="doctorTitle"
                              value={formInputs?.doctorTitle || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Speciality Code"
                              name="doctorSpecialityCode"
                              value={formInputs?.doctorSpecialityCode || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Speciality Name"
                              name="doctorSpecialityName"
                              value={formInputs?.doctorSpecialityName || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              value={formInputs?.doctorType || ""}
                              onChange={onInputChange}
                              error={validation?.doctorType}
                              disabled={disabled}
                              required
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Gender"
                              name="employeeGender"
                              data={employeeGender}
                              setValue={formInputs?.employeeGender}
                              getvalue={setDropdownData}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital/Clinic Name"
                              name="doctorHospitalName"
                              value={formInputs?.doctorHospitalName || ""}
                              onChange={onInputChange}
                              error={validation?.doctorHospitalName}
                              disabled={disabled}
                              required
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital Address"
                              name="doctorHospitalAddress"
                              value={formInputs?.doctorHospitalAddress || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Hospital City"
                              name="doctorHospitalCity"
                              value={formInputs?.doctorHospitalCity || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              value={formInputs?.doctorClass || ""}
                              onChange={onInputChange}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              label="Manager"
                              name="doctorManagerName"
                              data={doctorManagerDropDownOption}
                              setValue={formInputs?.doctorManagerName}
                              getvalue={setDropdownData}
                              disabled={disabled}
                            />
                          </Col>
                        </>
                      )}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Mobile"
                          name="mobileNr"
                          placeholder=""
                          value={formInputs?.mobileNr || ""}
                          onChange={onInputChange}
                          error={validation.mobileNr}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Email"
                          name="email"
                          required={true}
                          // placeholder="Enter Your Email Id"
                          value={formInputs.email || ""}
                          onChange={onInputChange}
                          disabled={disabled}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Gender"
                          name="employeeGender"
                          code="employeeGenderCode"
                          description="employeeGenderDesc"
                          data={employeeGender}
                          id="employeeGender"
                          iconClassName="dropdownIcon"
                          setValue={formInputs?.employeeGender}
                          error={validation.employeeGender}
                          getvalue={setDropdownData} // This should update getDropdownData
                          required={true}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label=" Address Lines 1 / Street"
                          name="address"
                          placeholder=""
                          value={formInputs?.address || ""}
                          onChange={onInputChange}
                          error={validation.address}
                          required={true}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Address Line 2"
                          name="address2"
                          placeholder=""
                          value={formInputs?.address2 || ""} 
                          onChange={onInputChange}
                          error={validation.address2}
                          required={true}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="City"
                          name="city"
                          placeholder=""
                          value={formInputs?.city || ""}
                          onChange={onInputChange}
                          error={validation.city}
                          required={true}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Country"
                          placeholder=""
                          data={getCountry}
                          id="country"
                          iconClassName="dropdownIcon"
                          name="country"
                          code="countryCode"
                          description="countryDesc"
                          setValue={formInputs?.country}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={disabled}
                          // error={validation.country}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="State"
                          placeholder=""
                          data={getState}
                          id="state"
                          iconClassName="dropdownIcon"
                          name="state"
                          code="stateCode"
                          description="stateDesc"
                          setValue={formInputs?.state}
                          getvalue={setDropdownData}
                          required={true}
                          disabled={disabled}
                          // error={validation.state}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Postal Code/PO Box"
                          name="cityPostalCode"
                          placeholder=""
                          value={formInputs?.cityPostalCode}
                          onChange={onInputChange}
                          error={validation?.cityPostalCode}
                          required={true}
                          disabled={disabled}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          label="Company Code"
                          extraLabel="Company Code"
                          placeholder=""
                          data={getCompanyCode}
                          id="companyCode"
                          iconClassName="dropdownIcon"
                          name="companyCode"
                          code="companyCodeCode"
                          description="companyCodeDesc"
                          setValue={formInputs.companyCode || ""}
                          getvalue={setDropdownData}
                          onChange={onInputChange}
                          error={validation.companyCode}
                          required={true}
                          disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Joining Date"
                          name="joiningDate"
                          id="joiningDate"
                          value={formInputs?.joiningDate}
                          onChange={onInputChange}
                          disabled={disabled}
                          // disabled={disabled}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding d-flex align-items-center"
                      >
                        <div>
                          <label
                            className="form-check-label fw-medium fs-6 text-dark mb-2 cursor-pointer me-2"
                            htmlFor="activeInactive"
                          >
                            Active/Inactive
                          </label>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input custom-switch"
                            type="checkbox"
                            role="switch"
                            name="activeInactive"
                            id="activeInactive"
                            checked={formInputs?.activeInactive || false}
                            onChange={(e) =>
                              setFormInputs((prev) => ({
                                ...prev,
                                activeInactive: e.target.checked,
                              }))
                            }
                            disabled={disabled}
                          />
                          <span className="ms-2">
                            {formInputs?.activeInactive ? "Active" : "Inactive"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* DOCTORS LIST (V04) */}
            {selectedVendorCategory?.code === "V04" && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${isCardVisible10 ? "bi-chevron-right" : "bi-chevron-down"}`}
                          onClick={toggleCardVisibility10}
                        ></i>
                      </Col>
                      <Col xs={1} className="text-center logoBtn">
                        <span className="iconLogo">DR</span>
                      </Col>
                      <Col xs={4} md={8} lg={8}>
                        <span className="headerTitle">Doctors List</span>
                        <span className="subHeaderTitle">
                          Add doctors employed by this hospital
                        </span>
                      </Col>
                      <Col
                        xs={4}
                        md={2}
                        lg={2}
                        className="d-flex justify-content-end"
                      >
                        <button
                          className="btnTable"
                          onClick={addDoctor}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add Doctor
                        </button>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""}`}
                  >
                    <div className="accordion-body">
                      {getDoctorsList.map((doc) => (
                        <Row key={doc.id} className="mb-3 border-bottom pb-3">
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Title"
                              value={doc.doctorTitle}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorTitle",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Name"
                              value={doc.doctorName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality Code"
                              name="doctorSpecialityCode"
                              placeholder="e.g. VS, DR, EN"
                              value={doc.doctorSpecialityCode}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityCode",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Doctor Speciality"
                              name="doctorSpecialityName"
                              value={doc.doctorSpecialityName}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorSpecialityName",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Type"
                              name="doctorType"
                              placeholder="e.g. Doctor, Physio"
                              value={doc.doctorType}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorType",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <ComboboxField
                              className="inputBox"
                              label="Gender"
                              name="doctorGender"
                              code="doctorGenderCode"
                              description="doctorGenderDesc"
                              id="doctorGender"
                              data={employeeGender}
                              setValue={doc.doctorGender}
                              getvalue={setDropdownData}
                              index={doc.id}
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Class"
                              name="doctorClass"
                              placeholder="e.g. FA, CORE"
                              value={doc.doctorClass}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorClass",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Rent Percentage"
                              name="doctorRentPercentage"
                              type="number"
                              value={doc.doctorRentPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorRentPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={3}
                            lg={3}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Discount Rate"
                              type="number"
                              name="doctorDiscountPercentage"
                              value={doc.doctorDiscountPercentage}
                              onChange={(e) =>
                                handleDoctorInputChange(
                                  doc.id,
                                  "doctorDiscountPercentage",
                                  e.target.value,
                                )
                              }
                              disabled={disabled}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={1}
                            lg={1}
                            className="commTopButtonRightLeftPadding d-flex align-items-center mt-4"
                          >
                            {!disabled && (
                              <i
                                className="bi bi-trash text-danger fs-4 cursor-pointer"
                                onClick={() => deleteDoctor(doc.id)}
                              ></i>
                            )}
                          </Col>
                        </Row>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/*Customer Contact Person / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CP</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Contact Person</span>
                      <span className="subHeaderTitle">
                        Customer Contact Person
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addCustomerCantactPerson}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={2} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Job Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Title
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Person
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Contact Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Email-ID
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getcustomerContactPerson.map(
                                      (doc, index) => (
                                        <Row key={doc.id}>
                                          <Col xs={12}>
                                            <hr className="mx-4 my-0 text-color-black" />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Job Title"
                                              data={getcontactPosition}
                                              id="contactPosition"
                                              iconClassName="dropdownIcon"
                                              name="contactPosition"
                                              code="contactPositionCode"
                                              description="contactPositionDesc"
                                              setValue={doc?.contactPosition}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              disabled={disabled}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <ComboboxField
                                              label=""
                                              placeholder="Contact Title"
                                              data={getTitle}
                                              id="contactTitle"
                                              iconClassName="dropdownIcon"
                                              name="contactTitle"
                                              code="contactTitleCode"
                                              description="contactTitleDesc"
                                              setValue={doc?.contactTitle}
                                              getvalue={setDropdownData}
                                              index={doc.id}
                                              onChangeValue={
                                                handleChangeCustomerContacts
                                              }
                                              disabled={disabled}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactName"
                                              placeholder="Contact Person"
                                              value={doc.contactName || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactName",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactName`
                                                ]
                                              }
                                              disabled={disabled}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              name="contactNumber"
                                              placeholder="Contact Number"
                                              value={doc.contactNumber || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactNumber",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactNumber`
                                                ]
                                              }
                                              disabled={disabled}
                                            />
                                          </Col>
                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={2}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <InputField
                                              className="inputBox mt-1"
                                              // label="Please Enter the Remarks*"
                                              name="contactEmail"
                                              placeholder="Email"
                                              value={doc.contactEmail || ""}
                                              onChange={(e) =>
                                                handleChangeCustomerContacts(
                                                  doc.id,
                                                  "contactEmail",
                                                  e.target.value,
                                                )
                                              }
                                              error={
                                                validation[
                                                  `${doc.id}_contactEmail`
                                                ]
                                              }
                                              disabled={disabled}
                                            />
                                          </Col>

                                          <Col
                                            xs={12}
                                            md={4}
                                            lg={1}
                                            className="commTopButtonRightLeftPadding"
                                          >
                                            <i
                                              onClick={() =>
                                                deleteCustomerContactPerosn(
                                                  doc.id,
                                                )
                                              }
                                              className="bi bi-trash text-danger fs-4"
                                            />
                                          </Col>
                                        </Row>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Document Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">DT</span>
                    </Col>
                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Document Type</span>
                      <span className="subHeaderTitle">Document Type</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3">
                        <button
                          className="btnTable"
                          onClick={addDocumentType}
                          disabled={disabled}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button>
                      </div>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={12}>
                                <div className="accordion-body">
                                  <div className="d-flex-column justify-content-center">
                                    <Row className="pt-4 d-none d-lg-flex ">
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Type
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Document Number
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issue Date
                                        </p>
                                      </Col>
                                      {/* <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Issuing Authority
                                        </p>
                                      </Col> */}
                                      <Col xs={12} md={4} lg={1}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          View Files
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex ms-4">
                                          Attachments
                                        </p>
                                      </Col>
                                      <Col xs={12} md={4} lg={2}>
                                        <p className="fs-6 fw-medium d-flex justify-content-center ms-4">
                                          Action
                                        </p>
                                      </Col>
                                    </Row>
                                    {getDocumentTypeData.map((doc, index) => (
                                      <Row key={doc.id}>
                                        <Col xs={12}>
                                          <hr className="mx-4 my-0 text-color-black" />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <ComboboxField
                                            label=""
                                            placeholder="Document type"
                                            data={getdocumentType}
                                            id="documentType"
                                            iconClassName="dropdownIcon"
                                            name="documentType"
                                            code="documentTypeCode"
                                            description="documentTypeDesc"
                                            setValue={doc?.documentType}
                                            getvalue={setDropdownData}
                                            index={doc.id}
                                            onChangeValue={handleInputChange}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            placeholder="Document Number"
                                            value={doc.documentNumber}
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "documentNumber",
                                                e.target.value,
                                              )
                                            }
                                            error={
                                              validation[
                                                `${doc.id}_documentNumber`
                                              ]
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={2}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <InputField
                                            className="inputBox"
                                            type="date"
                                            value={formatDateForInput(
                                              doc.issueDate,
                                            )} // Convert date format
                                            onChange={(e) =>
                                              handleInputChange(
                                                doc.id,
                                                "issueDate",
                                                e.target.value,
                                              )
                                            }
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <div className="d-flex justify-content-center">
                                            {(doc.iSOCertification && (
                                              <img
                                                src="assets/img/newIcons/attached-file.png"
                                                className="mt-1 attachmentIcon"
                                                alt="attachments"
                                                onClick={() =>
                                                  handleViewFile(
                                                    doc.iSOCertification,
                                                  )
                                                }
                                              />
                                            )) ||
                                              "--"}
                                          </div>
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={3}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <FileUploadComponent
                                            id={doc.id}
                                            name="iSOCertification"
                                            label=""
                                            allowedTypes={[
                                              "image/png",
                                              "image/jpeg",
                                              "application/pdf",
                                            ]}
                                            multiple={false} // Change to `false` for single file selection
                                            required={true}
                                            onSuccessUpload={
                                              onSuccessUploadDocumentType
                                            }
                                            value={doc.iSOCertification || ""}
                                            disabled={disabled}
                                          />
                                        </Col>
                                        <Col
                                          xs={12}
                                          md={4}
                                          lg={1}
                                          className="commTopButtonRightLeftPadding"
                                        >
                                          <i
                                            disabled={disabled}
                                            onClick={() =>
                                              deleteDocumentType(doc.id)
                                            }
                                            className="bi bi-trash text-danger fs-4"
                                          />
                                        </Col>
                                      </Row>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* 08 Banker Info*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible8
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BI</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Bank Information</span>
                      <span className="subHeaderTitle">
                        Bank Information (Please add all your Bank Accounts)
                      </span>
                    </Col>
                    <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        onClick={() => addBankForm()}
                        disabled={disabled}
                      >
                        <i className="bi bi-plus-lg"></i> Add Bank Info
                      </button>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <CommonFillter />
                    </Col>
                  </Row>
                </h2>

                {/* Banker Information */}
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible8 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {/* To Load Dynamic Bank Info Form */}
                    {getBankDetails &&
                      getBankDetails?.map((item, index) => (
                        <div key={item.id}>
                          <Row className="pt-2 pb-2">
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <h6>Bank Information Section {index + 1}</h6>
                              <span
                                className="deleteIconAccordion"
                                onClick={() => removeBankForm(index)}
                              >
                                {" "}
                                <i className="bi bi-x-circle"></i>{" "}
                              </span>
                            </Col>
                            {/* <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Is the Company bank included on list?"
                                placeholder=""
                                data={dropdownOption}
                                id="bankNotListed"
                                iconClassName="dropdownIcon"
                                name="bankNotListed"
                                setValue={item?.bankNotListed || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                                disabled={true}
                              />
                            </Col> */}

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* <ComboboxField
                                label="Bank IFSC ID"
                                placeholder=""
                                data={getBankDetailsData}
                                id="bankKey"
                                iconClassName="dropdownIcon"
                                name="bankKey"
                                setValue={item?.bankKey}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // error={
                                //   item.bankNotListed === "Yes"
                                //     ? validation[`${item.id}_bankKey`]
                                //     : ""
                                // }
                                disabled={true}

                                // disabled={getDisabledStatus}
                              /> */}
                              <InputField
                                className="inputBox"
                                label="Bank IFSC ID"
                                name="bankIFSC"
                                placeholder=""
                                value={item?.bankIFSC}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankIFSC",
                                    e.target.value,
                                  )
                                }
                                // disabled={getDisabledStatus}
                                disabled={disabled}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank A/C Number"
                                name="bankAccountNumber"
                                placeholder=""
                                value={item?.bankAccountNumber}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAccountNumber",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_bankAccountNumber`]
                                    : ""
                                }
                                disabled={disabled}
                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Name"
                                name="bankBranchName"
                                placeholder=""
                                value={item?.bankBranchName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankBranchName",
                                    e.target.value,
                                  )
                                }
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bank Country"
                                name="bankCountryDescription"
                                placeholder=""
                                value={item?.bankCountryDescription}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCountryDescription",
                                    e.target.value,
                                  )
                                }
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Branch Address"
                                name="bankAddress"
                                placeholder=""
                                value={item?.bankAddress}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankAddress",
                                    e.target.value,
                                  )
                                }
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Preferred Currency"
                                name="bankCurrency"
                                placeholder=""
                                value={item?.bankCurrency}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "bankCurrency",
                                    e.target.value,
                                  )
                                }
                                disabled={disabled}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Name of Beneficiary"
                                extraLabel="Name of Beneficiary (Bank Account Holder Name) as per company /trade license"
                                name="AccountHolderName"
                                placeholder=""
                                value={item?.AccountHolderName}
                                onChange={(e) =>
                                  handleChangeBankInfo(
                                    item.id,
                                    "AccountHolderName",
                                    e.target.value,
                                  )
                                }
                                error={
                                  item.bankNotListed === "Yes"
                                    ? validation[`${item.id}_AccountHolderName`]
                                    : ""
                                }
                                disabled={disabled}

                                // disabled={getDisabledStatus}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="IFSC Code"
                                placeholder=""
                                data={dropdownOption}
                                id="swiftIfscCode"
                                iconClassName="dropdownIcon"
                                name="swiftIfscCode"
                                setValue={item?.swiftIfscCode || ""}
                                getvalue={setDropdownData}
                                index={item.id}
                                onChangeValue={handleChangeBankInfo}
                                // disabled={getDisabledStatus}
                                disabled={disabled}
                              />
                            </Col>
                            <Row>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponentForHB
                                  id="bankCompanyletterhead"
                                  name="bankCompanyletterhead"
                                  label="Company letterhead"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true}
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankCompanyletterhead || ""}
                                  disabled={disabled}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponentForHB
                                  id="bankConfirmationLetter"
                                  name="bankConfirmationLetter"
                                  label="Confirmation letter"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true}
                                  required={true}
                                  onSuccessUpload={(data) =>
                                    onSuccessUploadBankDocumentType(data, index)
                                  }
                                  value={item?.bankConfirmationLetter || ""}
                                  disabled={disabled}
                                />
                              </Col>
                            </Row>
                            <Col
                              xs={12}
                              md={12}
                              lg={12}
                              className="commTopButtonRightLeftPadding"
                            >
                              <hr />
                            </Col>
                          </Row>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
        showDelete={!disabled}
      />
    </main>
  );
};

export default SupplierRegistrationDetailsMR;
